module.exports = __webpack_public_path__ + "BSPsIGDC-51ff54fc.webp";